import { render } from "./PricingWeekStrategyComponent.vue?vue&type=template&id=5d0fc224&scoped=true&ts=true"
import script from "./PricingWeekStrategyComponent.vue?vue&type=script&lang=ts"
export * from "./PricingWeekStrategyComponent.vue?vue&type=script&lang=ts"

import "./PricingWeekStrategyComponent.vue?vue&type=style&index=0&id=5d0fc224&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0fc224"]])

export default __exports__